import { useSelector } from 'react-redux'
import { SendStatusType } from '$logic/message'
import { RootState } from '$setup/redux'
import { roomPendingEditByIidView } from '$logic/pending-edits/react-hook'
import { roomPendingEditUploadByIidView } from '$logic/pending-edit-uploads/react-hook'

export function useSendStatus(iid: number, roomId: string) {
  return useSelector((state: RootState) => {
    const pendingEdit = roomPendingEditByIidView(roomId, iid)(state)
    const pendingEditUpload = roomPendingEditUploadByIidView(roomId, iid)(state)

    const { seenIid, receivedIid } = state.main.rooms[roomId] || {}
    return !iid || pendingEdit || pendingEditUpload
      ? 'PENDING'
      : iid <= seenIid
      ? 'SEEN'
      : iid <= receivedIid
      ? 'RECEIVED'
      : ('SENT' as SendStatusType)
  })
}
